//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { cloneDeep, isEmpty, isUndefined, map, isEqual, filter, reduce, find, isNull } from 'lodash'
import styled from 'styled-components'
import moment from 'moment'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
//////COMPONENTS//////
import Table from '../../components/Table'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import { SalesHistoryManagerNested, SalesHistoryStatus, SalesHistoryPaymentStatus } from './Components'
import { salesHistoryManagerActionCreators, columnsActionCreators, tableActionCreators, exportDatasActionCreators } from '../../store/actions'
import { uriList } from '../../routings/settings/RouteList'
import Button from '../../components/Ui/Buttons'
import Theme from '../../theme/theme'
import Modals from '../../components/Modals'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import ToggleFilters from '../../components/Ui/ToggleFilters'
import UseDatePicker from '../../hooks/UseDatePicker'
import { LabelText, InputLogin, TextModal, DatePickerFilterLabel } from '../../theme/GlobalCss'
import UseCheckAll from '../../hooks/UseCheckAll'
import TooltipHelp from '../../components/TooltipHelp'
import urlExport from '../../constants/UrlExport'
import userPrivileges from '../../constants/PrivilegesList'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'
import Calendar from '../../assets/icones/global/calendar.svg'

//////STYLED//////
const UsersManagerWrapper = styled.div`
	position: relative;
`
const DatePickerTransactionIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	justify-content: space-between;
	margin-left: 5px;
	margin-right: 5px;
	width: 100%;
`
// ---> Guest ticket
const InputLabelWrapper = styled.div`
	max-width: 100%;
	display: flex;
	justify-content: space-around;
	margin-bottom: 15px;
	margin-top: ${(props) => props.modalTitle === 'contract' && props.theme.margin.mt};
`
const InputWrapper = styled.div`
	max-width: auto;
	max-height: auto;
	display: flex;
	flex-direction: column;
`
const InputLoginCustom = styled(InputLogin)`
	width: 150px;
	border: 1px solid ${(props) => props.theme.colors.cancel};
	margin-right: 15px;
	margin-top: 5px;
`
const ErrorInputMsg = styled.div`
	width: max-content;
	color: ${(props) => props.theme.colors.error};
`
const RejectText = styled.div`
	font-style: italic;
	text-align: center;
	margin-bottom: 25px;
`

const SuccessText = styled(RejectText)`
	color: ${Theme.colors.validation};
`
//////STYLED//////

const SalesHistoryManager = () => {
	const {
		user,
		translations,
		salesHistoryManager,
		salesHistoryFilters,
		userKioskPerimeter,
		userRolePrivileges,
		isSearchfieldUpdated,
		currentColumn,
		currentDir,
		exportDataByEmail,
	} = useSelector(
		(state) => ({
			translations: state.languages.translations,
			salesHistoryManager: state.salesHistoryManager,
			salesHistoryFilters: state.salesHistoryManager.header,
			user: state.user,
			userKioskPerimeter: state.user.identity.kioskSelected,
			userRolePrivileges: state.user.identity.rolePrivileges,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
			exportDataByEmail: state.exportDataByEmail,
		}),
		shallowEqual
	)

	let history = useHistory()
	const actionsSalesHistoryManager = bindActionCreators(salesHistoryManagerActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())
	const actionsExportDatas = bindActionCreators(exportDatasActionCreators, useDispatch())

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	// Data
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'date', nameDir: 'desc' })

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Modals
	const [row, setRow] = useState({})
	const [showModalTicket, setShowModalTicket] = useState(false)
	const [showGuestTicketModal, setShowGuestTicketModal] = useState(false)
	const [stateDefaultValues, setStateDefaultValues] = useState()

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])
	const [
		dateTransactionShowModal,
		dateTransactionOpenDateModalHandler,
		dateTransactionRenderModal,
		dateTransactionStateDate,
		setStartDate,
		setEndDate,
	] = UseDatePicker({
		defaultDateStart: moment().startOf('day').subtract(6, 'days').toDate(),
		defaultDateEnd: moment().hours(23).minutes(59).toDate(),
	})

	const { register, handleSubmit, setValue, errors, getValues } = useForm({
		defaultValues: stateDefaultValues,
	})

	// Columns
	const [columns, setColumns] = useState([])

	const [showExportModal, setShowExportModal] = useState(false)

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handlePagingSalesHistory = (paging) => {
		// Force reset paging at zero, in case when filters are preventing any pagination with current size

		const pg = {
			...paging,
			...{
				sort: !isUndefined(currentColumn.value) ? currentColumn.value : 'date',
				nameDir: !isUndefined(currentDir.value) ? currentDir.value : 'desc',
			},
		}
		setPaging(pg)
		actionsSalesHistoryManager.getSalesHistory(handleFilterSend(), pg)
	}

	const handleSeeConsignation = (row) => {
		actionsSalesHistoryManager.setTransactionNumber(row)
		actionsTable.setIsFromRedirect()
		history.push(`${uriList.sales}${uriList.consignation}`)
	}

	const handleSeeTelecollect = (paymentCollectionId) => {
		actionsSalesHistoryManager.setTelecollectId(paymentCollectionId)
		history.push(`${uriList.sales}${uriList.telecollectManager}`)
	}

	const handleModalTicket = (dataRow) => {
		setRow({ ...dataRow })
		setShowModalTicket((prevState) => !prevState)
	}

	const handleGuestTicketModal = (dataRow) => {
		setRow({ ...dataRow })
		setShowGuestTicketModal((prevState) => !prevState)
	}

	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSelectedWithTTC = () => {
		let filtersCP = cloneDeep(filters)
		const str_filters = handleFilterSend()
		str_filters.pricesTTC = !filtersCP.pricesTTC
		str_filters.searchField = searchValue
		filtersCP.pricesTTC = !filtersCP.pricesTTC
		setFilters(filtersCP)
		actionsSalesHistoryManager.getSalesHistory(str_filters, paging)
	}

	const handleSubmiFilter = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change
		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', sort: 'date', nameDir: 'desc' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsSalesHistoryManager.getSalesHistory(handleFilterSend(), pg)
	}
	const handleFilterSend = () => {
		// Prepping stores and kiosks selected
		// In UI, stores and kiosks are independant in listing and selection
		// But here, we need to regroup kiosks with their stores
		// {
		// 	"selectedStoreId": 4,
		// 	"selectedKiosksIds": [3,2]
		// },
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}

		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		let arr_selectedStoresKiosksIds = []
		map(filters.availableStores, (store) => {
			let rst = {}
			if (store.active) {
				rst.selectedStoreId = store.id

				// Extract kiosks
				let kiosks = map(filter(store.availableKiosks, { active: true }), 'id')
				rst.selectedKiosksIds = kiosks
			}

			if (!isEmpty(rst)) arr_selectedStoresKiosksIds.push(rst)
		})

		return {
			...filtersOut,
			withFilters: true,
			userKioskScope: {
				kiosksInLocalScope: reduce(
					user.identity.kioskSelected,
					(result, value) => {
						result.push(value.id)
						return result
					},
					[]
				),
			},
			datesRange: {
				dateStart: dateTransactionStateDate.date.startDate,
				dateEnd: dateTransactionStateDate.date.endDate,
			},
		}
	}

	const handleTicketAsk = () => {
		actionsSalesHistoryManager.sendMerchantTicket(row.id)
		setShowModalTicket(false)
	}

	const handleGuestTicketAsk = (data) => {
		if (!isUndefined(data)) {
			actionsSalesHistoryManager.sendGuestTicket(row.id, data)
			setShowGuestTicketModal(false)
		}
	}

	const handleExportModal = () => {
		if (!showExportModal) {
			actionsExportDatas.resetExportDatasByEmail()
			setValue('exportEmail', user.identity.email)
		}
		setShowExportModal(!showExportModal)
	}

	const handleExportByEmailAsk = () => {
		const email = getValues('exportEmail')
		actionsExportDatas.postExportDatasByEmail(
			{ ...configTable.export.bd, recipientEmail: email },
			urlExport[22]            // le nouvel index ajouté
		)
	}
	/////////////////////////////// CONFIG //////////////////////////////////////

	useEffect(() => {
		setColumns([
			/*{ dataHook: 'id', headerName: '', "isAuthorize": false, component: SalesHistoryToggleNested, sortable: false },*/
			{
				columnReferential: 'saleHistory_transactionStatus',
				dataHook: 'salesOrderStatus.translationKey',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_transactionStatus'],
				sortable: true,
				isAuthorize: true,
				component: SalesHistoryStatus,
				sortableId: 'status.description',
			},
			{
				columnReferential: 'saleHistory_transactionNumber',
				dataHook: 'idTransaction',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_transactionNumber'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'transactionId',
			},
			{
				columnReferential: 'saleHistory_transactionDate',
				dataHook: 'dateCreated',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_transactionDate'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (props.row.dateCreated === null ? '-' : moment(props.row.dateCreated).utc().format('DD/MM/YYYY HH:mm')),
				sortableId: 'date',
			},
			{
				columnReferential: 'saleHistory_KioskCode',
				dataHook: 'kioskCode',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_kioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.labelToManufacturer',
			},
			{
				columnReferential: 'saleHistory_kioskName',
				dataHook: 'kioskName',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_kioskName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.description',
			},
			{
				columnReferential: 'saleHistory_clientKioskCode',
				dataHook: 'customerKioskCode',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_kioskCodeCustomer'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.labelToOwner',
			},
			{
				columnReferential: 'saleHistory_distributor',
				dataHook: 'distributorLabelToDisplay',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_distributorLabel'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'distributor.company.labelToDisplay',
			},
			{
				columnReferential: 'saleHistory_transactionType',
				dataHook: 'salesOrderType.translationKey',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_transactionType'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'saleOrderType.translationKey.id',
			},
			{
				columnReferential: 'saleHistory_paymentType',
				dataHook: 'paymentType.translationKey',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_paymentType'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'paymentType.translationKey.id',
			},
			{
				columnReferential: 'saleHistory_code',
				dataHook: 'code',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_salesOrderCode'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (props.row.paymentType.idPaymentType === 2 ? props.row.code : '-'),
				sortableId: 'code',
			},
			{
				columnReferential: 'saleHistory_paymentStatus',
				dataHook: 'paymentStatus.translationKey',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_paymentStatus'],
				sortable: true,
				isAuthorize: true,
				component: SalesHistoryPaymentStatus,
				sortableId: 'paymentStatus.translationKey.id',
			},
			{
				columnReferential: 'saleHistory_amountTransaction',
				dataHook: 'transactionTotalAmout',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_transactionAmount'],
				sortable: true,
				isAuthorize: true,
				component: (props) => `${props.row.transactionTotalAmout}${props.row.currency.symbol}`,
				sortableId: 'totalPriceTTC',
			},
			{
				columnReferential: 'saleHistory_VAT',
				dataHook: 'vatAmount',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_tvaAmount'],
				sortable: true,
				isAuthorize: true,
				component: (props) => `${props.row.vatAmount}${props.row.currency.symbol}`,
				sortableId: 'vatAmountTTC',
			},
			{
				columnReferential: 'saleHistory_promotion',
				dataHook: 'withPromo',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_withPromotion'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (props.row.withPromo ? translations['common__text__yes'] : translations['common__text__no']),
				sortableId: 'salesOrderLineWithPromo.id',
			},
			{
				columnReferential: 'saleHistory_clientInfo',
				dataHook: 'withCustomerInfo',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_withCustomerInfo'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (props.row.withCustomerInfo ? translations['common__text__yes'] : translations['common__text__no']),
				sortableId: 'customerLastname',
			},
			{
				columnReferential: 'saleHistory_consignmentInfo',
				dataHook: 'withDeposit',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_withConsignment'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (props.row.withDeposit ? translations['common__text__yes'] : translations['common__text__no']),
				sortableId: 'salesOrderLineWithDeposit.withDeposit',
			},
			{
				columnReferential: 'saleHistory_dateKioskTransferIn',
				dataHook: 'dateKioskTransferIn',
				headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_dateKioskTransferIn'],
				sortable: true,
				isAuthorize: true,
				component: (props) =>
					!isNull(props.row.dateKioskTransferIn) ? moment(props.row.dateKioskTransferIn).format('DD/MM/YYYY HH:mm') : '-',
				sortableId: 'dateKioskTransferIn',
			},
			// [147] Masking this column
			/*{
					dataHook: 'toCorrectedComparison',
					headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_paymentCollection_isComparisonSucces'],
					sortable: true,
					isAuthorize: true,
					component: (props) => (props.row.toCorrectedComparison ? translations['common__text__yes'] : translations['common__text__no']),
				},*/
			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				withIcons: false,
				rest: {
					tooltipPart: 'salesHistoryManager',
					paperActionsList: [
						{
							name: translations['tooltip__admin__global__action__consignmentContract_detail'],
							translationKey: 'tooltip__admin__global__action__consignmentContract_detail',
							clickAction: (row) => {
								handleSeeConsignation(row)
							},
							isVisible: (row) =>
								row.salesOrderType?.id === 1 &&
								row.withDeposit === true &&
								!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[11])),
							//iconDef: badge,
						},
						{
							name: translations['tooltip__admin__global__action__salesTicket_detail'],
							translationKey: 'tooltip__admin__global__action__salesTicket_detail',
							clickAction: (row) => {
								handleModalTicket(row)
							},
							isVisible: (row) => !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[9])),
							//iconDef: group,
						},
						{
							name: translations['tooltip__admin__global__action__paymentCollection_detail'],
							translationKey: 'tooltip__admin__global__action__paymentCollection_detail',
							clickAction: (row) => {
								handleSeeTelecollect(row)
							},
							isVisible: (row) =>
								!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[13])) &&
								!isNull(row.paymentCollectionId),
							//icon: eye,
						},
						{
							name: translations['page__transactionsHistory__admin__customerTicket_detail_tableAction_sendTicket'],
							translationKey: 'tooltip__admin__global__action__customerTicket_detail',
							clickAction: (row) => {
								handleGuestTicketModal(row)
							},
							isVisible: (row) =>
								!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[33])) &&
								row.canSendCustomerTicketByEmail,
							//icon: guestTicket,
						},
					],
				},
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 8,
		labelPageTable: 'saleHistory',
	}

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	//Config

	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},
			toggleLists: [
				() => (
					<ToggleFilters
						defaultChecked
						onChangeHandler={handleSelectedWithTTC}
						name="selectedwithTTC"
						labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
						labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
					/>
				),
			],
			dateLists: [
				() => (
					<Fragment>
						<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
							{translations['page__global__admin__header__transactionDate']} :
						</label>
						<DatePickerTransactionIcon onClick={dateTransactionOpenDateModalHandler} />
						<DatePickerFilterLabel>
							<span>
								{translations['page__global__admin__header_datePicker_from']}{' '}
								{isEqual(dateTransactionStateDate.date.startDate, {})
									? moment(new Date()).subtract(6, 'days').format('DD/MM/YYYY HH:mm')
									: moment(dateTransactionStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
							</span>
							<span>
								{translations['page__global__admin__header_datePicker_to']}{' '}
								{isEqual(dateTransactionStateDate.date.endDate, {})
									? moment(new Date()).format('DD/MM/YYYY HH:mm')
									: moment(dateTransactionStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
							</span>
						</DatePickerFilterLabel>
					</Fragment>
				),
			],
		},

		paging: {
			fnSendTo: (paging) => handlePagingSalesHistory(paging),
		},
	})
	const [configTable, setConfigTable] = useState({
		nestedValues: {
			value: true,
			nestedData: 'salesOrderLines',
			nestedComponent: SalesHistoryManagerNested,
			nestedPointer: 'id', // To retrieve index of line which is nested toggled or not => nestedPointer = nestedPointerValuePath
			nestedPointerValuePath: 'props.row.id', // To retrieve value of line which is nested toggled or not => nestedPointer = nestedPointerValuePath
			toggleAllNestedPointer: 'toggleNested', // Are we seeing nested lines or not
		},
	})

	useEffect(() => {
		if (dateTransactionStateDate.showModal) {
			actionsSalesHistoryManager.getSalesHistory(handleFilterSend(), paging)
		}
	}, [dateTransactionShowModal])

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(salesHistoryManager) && !isUndefined(salesHistoryManager)) {
			cfg.paging = {
				totalElements: salesHistoryManager.paging.totalElements,
				totalPages: salesHistoryManager.paging.totalPages,
				fnSendTo: (paging) => handlePagingSalesHistory(paging),
			}
			setConfigTableTitle(cfg)
		}
	}, [salesHistoryManager])

	useEffect(() => {
		setFilters(salesHistoryFilters)
		setPrevFilter(salesHistoryFilters)
	}, [salesHistoryFilters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)
		cfg.name = translations['page__transactionsHistory__title']
		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['page__transactionsHistory__admin__filters_transactionType']}
					data={filters.filtersSelection?.transactionTypes.filterElements}
					translations={translations}
					toTranslate
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmiFilter}
					target={'transactionTypes'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__saleHistory__tableHeader_kioskCustomerCode']}
					data={filters.filtersSelection?.kiosks.filterElements}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmiFilter}
					target={'kiosks'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__transactionsHistory__admin__filters_store']}
					data={filters.filtersSelection?.stores.filterElements}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmiFilter}
					target={'stores'}
				/>
			),
		]
		cfg.actions.toggleLists = [
			() => (
				<TooltipHelp content={'tooltipHelp__admin__modal__body__table__filter__vatSwitch'} childrenPos={2}>
					<ToggleFilters
						checked={filters.pricesTTC}
						onChangeHandler={handleSelectedWithTTC}
						size={'large'}
						name="selectedwithTTC"
						labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
						labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
					/>
				</TooltipHelp>
			),
		]
		cfg.actions.dateLists = [
			() => (
				<Fragment>
					<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
						{translations['page__global__admin__header__transactionDate']} :
					</label>
					<DatePickerTransactionIcon onClick={dateTransactionOpenDateModalHandler} />
					<DatePickerFilterLabel>
						<span>
							{translations['page__global__admin__header_datePicker_from']}{' '}
							{moment(dateTransactionStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
						</span>
						<span>
							{translations['page__global__admin__header_datePicker_to']}{' '}
							{moment(dateTransactionStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
						</span>
					</DatePickerFilterLabel>
				</Fragment>
			),
		]

		cfg.paging = {
			totalElements: salesHistoryManager.paging.totalElements,
			totalPages: salesHistoryManager.paging.totalPages,
			fnSendTo: (paging) => handlePagingSalesHistory(paging),
		}

		setConfigTableTitle(cfg)
	}, [translations, filters, dateTransactionStateDate])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)
		cfgCp.export = {
			privilege: userPrivileges.export[5],
			url: urlExport[5],
			fnOpenExportModal: handleExportModal,
			bd: {
				filtersSelection: filters.filtersSelection,
				withFilters: true,
				searchField: searchValue,
				pricesTTC: filters.pricesTTC,
				datesRange: { dateEnd: dateTransactionStateDate.date.endDate, dateStart: dateTransactionStateDate.date.startDate },
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			},
		}
		cfgCp.exportMerchantTicket = {
			privilege: userPrivileges.export[21],
			allowMerchantTicket: user.identity.company.allowMerchantTicketExport,
			url: urlExport[20],
			bd: {
				filtersSelection: filters.filtersSelection,
				withFilters: true,
				searchField: searchValue,
				pricesTTC: filters.pricesTTC,
				datesRange: { dateEnd: dateTransactionStateDate.date.endDate, dateStart: dateTransactionStateDate.date.startDate },
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			},
		}

		setConfigTable(cfgCp)
	}, [translations, filters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	const [swytch, setSwytch] = useState(false)

	useEffect(() => {
		if (!isUndefined(user) || !isEmpty(searchValue)) {
			setSwytch(true)
		}
	}, [user, searchValue])

	useEffect(() => {
		return function cleanUp() {
			actionsSalesHistoryManager.resetTransactionItems()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		const userCp = cloneDeep(user)
		const isPriceTTC = userCp.identity.isPricesTTC
		if (isUndefined(user) || isEmpty(translations)) return
		if (swytch) {
			let state_date = {}
			// If we got data from store, we set dates here
			if (!isEmpty(salesHistoryManager.transactionNumber)) {
				if (salesHistoryManager.transactionNumber.transactionDate) {
					// For request
					state_date.startDate = moment(salesHistoryManager.transactionNumber.transactionDate).subtract(3, 'hours')
					state_date.endDate = moment(salesHistoryManager.transactionNumber.transactionDate).add(3, 'hours')
					setFilters({ searchField: salesHistoryManager.transactionNumber.contractPo })
					// And for state of datepicker
					setStartDate(moment(state_date.startDate).toDate())
					setEndDate(moment(state_date.endDate).toDate())
				} else if (salesHistoryManager.transactionNumber.dateCreated) {
					// For request
					state_date.startDate = moment(salesHistoryManager.transactionNumber.dateCreated).subtract(3, 'hours')
					state_date.endDate = moment(salesHistoryManager.transactionNumber.dateCreated).add(3, 'hours')
					setFilters({ searchField: salesHistoryManager.transactionNumber.idTransaction })
					// And for state of datepicker
					setStartDate(moment(state_date.startDate).toDate())
					setEndDate(moment(state_date.endDate).toDate())
				} else if (salesHistoryManager.transactionNumber.creationDate) {
					/* else if (salesHistoryManager.transactionNumber.expirationDate) {
					// For request
					state_date.startDate = moment(salesHistoryManager.transactionNumber.expirationDate).subtract(3,'hours')
					state_date.endDate = moment(salesHistoryManager.transactionNumber.expirationDate).add(3,'hours')
					setFilters({searchField: salesHistoryManager.transactionNumber.idTransaction})
					// And for state of datepicker
					setStartDate(moment(state_date.startDate).toDate())
					setEndDate(moment(state_date.endDate).toDate())
				}  */
					// For request
					state_date.startDate = moment(salesHistoryManager.transactionNumber.creationDate).subtract(3, 'hours')
					state_date.endDate = moment(salesHistoryManager.transactionNumber.creationDate).add(3, 'hours')
					setFilters({ searchField: salesHistoryManager.transactionNumber.idTransaction })
					// And for state of datepicker
					setStartDate(moment(state_date.startDate).toDate())
					setEndDate(moment(state_date.endDate).toDate())
				}
			} else {
				// Or default case
				state_date.startDate = moment().startOf('day').subtract(6, 'days').toDate()
				state_date.endDate = moment().hours(23).minutes(59).toDate()
			}
			const filtersCp = {
				withFilters: false,
				searchField: searchValue,
				pricesTTC: isPriceTTC,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
				datesRange: {
					dateStart: state_date.startDate,
					dateEnd: state_date.endDate,
				},
				searchFieldUpdated: searchValue?.length > 0 ? true : false,
			}

			actionsSalesHistoryManager.getSalesHistory(filtersCp)
			setFilters(filtersCp)
			actionsColumns.setColumns([])
		}
	}, [swytch, translations])

	useEffect(() => {
		// If we came from redirection
		// we need to add on payload id for research, before tha  we use dateCreated to make research , but we have or we can have more result that we want to
		// we had get this choice to can research all transaction status
		let filtersCP = cloneDeep(filters)
		if (!isEmpty(salesHistoryManager.transactionNumber)) {
			// if we come from consignation
			if (!isUndefined(salesHistoryManager.transactionNumber.transactionPo)) {
				setSearchValue(salesHistoryManager.transactionNumber.transactionPo)
				filtersCP.searchField = salesHistoryManager.transactionNumber.transactionPo
			}
			if (!isUndefined(salesHistoryManager.transactionNumber.idTransaction)) {
				setSearchValue(salesHistoryManager.transactionNumber.idTransaction)
				filtersCP.searchField = salesHistoryManager.transactionNumber.idTransaction
			}
			if (!isUndefined(salesHistoryManager.transactionNumber.saleCode)) {
				setSearchValue(salesHistoryManager.transactionNumber.saleCode)
				filtersCP.searchField = salesHistoryManager.transactionNumber.saleCode
			}
		}
		setFilters(filtersCP)
	}, [salesHistoryManager.transactionNumber])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks))
			actionsSalesHistoryManager.getSalesHistory(
				{
					withFilters: false,
					userKioskScope: {
						kiosksInLocalScope: reduce(
							user.identity.kioskSelected,
							(result, value) => {
								result.push(value.id)
								return result
							},
							[]
						),
					},
					datesRange: {
						dateStart: moment().startOf('day').subtract(6, 'days').toDate(),
						dateEnd: moment().hours(23).minutes(59).toDate(),
					},
					pricesTTC: user.identity.isPricesTTC,
				},
				paging
			)
		setCurrentPerimeterKiosks(userKioskPerimeter)
		setStartDate(moment().startOf('day').subtract(6, 'days').toDate())
		setEndDate(moment().hours(23).minutes(59).toDate())
	}, [userKioskPerimeter])

	// guest mail
	useEffect(() => {
		setValue('lastName', row.customerLastName)
		setValue('firstName', row.customerName)
		setValue('email', row.customerEmail)

		setStateDefaultValues(getValues)
	}, [row])

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	// we make a guard to prevent 2 back call
	useEffect(() => {
		if (
			filters.searchField !== searchValue ||
			searchValue === salesHistoryManager.transactionNumber.transactionPo ||
			searchValue === salesHistoryManager.transactionNumber.idTransaction ||
			searchValue === salesHistoryManager.transactionNumber.saleCode
		) {
			return
		}
		handleSubmiFilter()
	}, [filters.searchField])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={salesHistoryManager.items}
				inputConfig={configTable}
				isLoading={salesHistoryManager.isLoading}
				currentPaging={paging}
				tableReferential={tableReferential}
				actionSort={actionsSalesHistoryManager.getSalesHistory}
			/>
		)
	}, [salesHistoryManager, columns, configTable, translations, paging])
	return (
		<Fragment>
			{dateTransactionRenderModal()}
			<Modals
				title={translations['modal__transactionsHistory__admin__title__sendMerchantTicket']}
				closeModalHandler={handleModalTicket}
				showModal={showModalTicket}
				icon={true}
			>
				<TextModal>
					<p>{translations['modal__transactionsHistory__admin__body__sendMerchantTicket']}</p>
				</TextModal>
				<ButtonWrapper>
					<Button
						actionHandler={handleModalTicket}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => {
							handleTicketAsk()
						}}
						text={translations['modal_transactionsHistory__admin__validation']}
						bgColor={Theme.colors.validation}
						img={Validation}
						width={250}
					/>
				</ButtonWrapper>
			</Modals>

			{/* MODAL GUEST TICKET*/}
			<Modals
				title={translations['modal__transactionsHistory__title__customerTicket__sendTicket']}
				closeModalHandler={handleGuestTicketModal}
				showModal={showGuestTicketModal}
				icon={true}
			>
				<form onSubmit={handleSubmit(handleGuestTicketAsk)}>
					<InputLabelWrapper>
						<InputWrapper>
							<LabelText>
								{translations['page__transactionsHistory__admin__consignmentContract__modalCommon__field_lastName']}* :
							</LabelText>
							<InputLoginCustom
								name="lastName"
								type="text"
								placeholder={translations['page__transactionsHistory__admin__consignmentContract__modalCommon__placeHolder_lastName']}
								ref={register({
									required: {
										value: true,
										message: translations['common__text__requiredField'],
									},
								})}
							/>
							{errors?.lastName && <ErrorInputMsg>{errors?.lastName.message}</ErrorInputMsg>}
						</InputWrapper>
						<InputWrapper>
							<LabelText>
								{translations['page__transactionsHistory__admin__consignmentContract__modalCommon__field_firstName']}* :
							</LabelText>
							<InputLoginCustom
								name="firstName"
								type="text"
								placeholder={
									translations['page__transactionsHistory__admin__consignmentContract__modalCommon__placeHolder_firstName']
								}
								ref={register({
									required: {
										value: true,
										message: translations['common__text__requiredField'],
									},
								})}
							/>
							{errors?.firstName && <ErrorInputMsg>{errors?.firstName.message}</ErrorInputMsg>}
						</InputWrapper>
						<InputWrapper>
							<LabelText>
								{translations['page__transactionsHistory__admin__consignmentContract__modalCommon__field_email']}* :
							</LabelText>
							<InputLoginCustom
								name="email"
								type="text"
								placeholder={translations['page__transactionsHistory__admin__consignmentContract__modalCommon__placeHolder_email']}
								ref={register({
									required: {
										value: true,
										message: translations['common__text__requiredField'],
									},
									pattern: {
										value: RegExp(
											/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
										),
										message: translations['common__text__invalidEmail'],
									},
								})}
							/>
							{errors?.email && <ErrorInputMsg>{errors?.email.message}</ErrorInputMsg>}
						</InputWrapper>
					</InputLabelWrapper>
					<p>{translations['modal__transactionsHistory__body__customerTicket__sendTicket']}</p>
					<RejectText>{translations['modal__transactionsHistory__body__customerTicket_extra_noCommercial__sendTicket']}</RejectText>
					<ButtonWrapper>
						<Button
							actionHandler={handleGuestTicketModal}
							text={translations['common__text__cancel']}
							bgColor={Theme.colors.error}
							margin="true"
							img={Cancel}
							type="submit"
						/>
						<Button
							actionHandler={() => {
								handleGuestTicketAsk()
							}}
							text={translations['common__text__validate']}
							bgColor={Theme.colors.validation}
							img={Validation}
							width={250}
						/>
					</ButtonWrapper>
				</form>
			</Modals>
			{/* MODAL EXPORT BY EMAIL */}
			<Modals
				title={translations['modal__transactionsHistory__title__exportByEmail']}
				closeModalHandler={handleExportModal}
				showModal={showExportModal}
				icon={true}
			>
				<form onSubmit={handleSubmit(handleExportByEmailAsk)}>
					<InputLabelWrapper>
						<InputWrapper>
							<LabelText>{translations['modal__transactionsHistory__exportByEmail__field_email']}* :</LabelText>
							<InputLoginCustom
								name="exportEmail"
								type="text"
								defaultValue={user.identity.email}
								ref={register({
									required: { value: true, message: translations['common__text__requiredField'] },
									pattern: {
										value: RegExp(/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
										message: translations['common__text__invalidEmail'],
									},
								})}
							/>
							{errors?.exportEmail && <ErrorInputMsg>{errors?.exportEmail.message}</ErrorInputMsg>}
						</InputWrapper>
					</InputLabelWrapper>
					<p>{translations['modal__transactionsHistory__exportByEmail__body']}</p>

					{exportDataByEmail.status === 'success' && (
						<SuccessText>{translations['modal__transactionsHistory__exportByEmail__success']}</SuccessText>
					)}
					{exportDataByEmail.status === 'error' && (
						<RejectText>{translations['modal__transactionsHistory__exportByEmail__error']}</RejectText>
					)}

					<ButtonWrapper>
						<Button actionHandler={handleExportModal} text={translations['common__text__cancel']}
							bgColor={Theme.colors.error} margin="true" img={Cancel} />
						<Button actionHandler={handleSubmit(handleExportByEmailAsk)} text={translations['common__text__validate']}
							bgColor={Theme.colors.validation} img={Validation} width={250} />
					</ButtonWrapper>
				</form>
			</Modals>
			<UsersManagerWrapper>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</UsersManagerWrapper>
		</Fragment>
	)
}

SalesHistoryManager.propTypes = {}

SalesHistoryManager.defaultPropTypes = {}

export default SalesHistoryManager
